export default __webpack_public_path__ + "static/media/vivabonito15.8296d491.jpg";